import {MappedDeliveryOptions, DeliveryOptionsErrors} from '@wix/delivery-section-cart/types';
import {DeliverySectionOptionModel} from './DeliverySectionOption.model';

export class DeliverySectionModel {
  public options: DeliverySectionOptionModel[];
  public optionsJson: string;
  public errors: DeliveryOptionsErrors;
  public canShipToDestination: boolean;
  public hasTimerSlots: boolean;
  public selectedOptionTitle: string;

  constructor(options: MappedDeliveryOptions, selectedCarrierId: string) {
    this.errors = options.errors;
    this.canShipToDestination = options.canShipToDestination;
    const {hasShippingZipCodeError, hasShippingDestinationError, hasShippingSubdivisionError} = this.errors;
    const deliveryOptionsNotValid =
      this.canShipToDestination &&
      (hasShippingZipCodeError || hasShippingDestinationError || hasShippingSubdivisionError);

    const {deliveryMethods, pickupMethods} = options.deliveries;
    const methods = [...deliveryMethods, ...pickupMethods];

    this.optionsJson = JSON.stringify(methods);
    this.hasTimerSlots = methods.some((option) => option.hasTimeSlots);
    this.options = deliveryOptionsNotValid
      ? []
      : methods.map((option) => new DeliverySectionOptionModel(option)) || /* istanbul ignore next */ [];
    this.selectedOptionTitle = this.options.find((option) => option.id === selectedCarrierId)?.value;
  }
}
